import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DirectionProvider } from '@radix-ui/react-direction';
import { LayerContext } from '@aibify/display/client';
import { layers } from './lib/layers.ts';
import { App } from './App.tsx';
import { ApiError } from './lib/api.ts';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { ConnectionPill } from './components/ConnectionPill.tsx';
import './index.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // 4xx הם תשובה של השרת — לא מנסים שוב; רשת/5xx — פעם אחת
      retry: (n, e) => !(e instanceof ApiError && e.status >= 400 && e.status < 500) && n < 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DirectionProvider dir="rtl">
      <QueryClientProvider client={qc}>
        <BrowserRouter>
          <ErrorBoundary>
            {/* Esc בשכבות (web-screen-budget): הגדלה, sheet ו-drawer במחסנית אחת */}
            <LayerContext.Provider value={layers}>
              <App />
            </LayerContext.Provider>
          </ErrorBoundary>
        </BrowserRouter>
        <ConnectionPill />
      </QueryClientProvider>
    </DirectionProvider>
  </StrictMode>,
);
